const UserPermissionsConstants = {
    PERMISSIONS: {
        ADD_LISTING: 'ADD_LISTING',
        UPDATE_LISTING: 'UPDATE_LISTING',
        VIEW_INVOICE: 'VIEW_INVOICE',
        VIEW_CONTACT: 'VIEW_CONTACT',
        RESPOND_REVIEW: 'RESPOND_REVIEW',
        VIEW_ANALYTICS: 'VIEW_ANALYTICS',
        COMPANY_ADMIN: 'COMPANY_ADMIN',
        SYNC_PROPERTIES: 'SYNC_PROPERTIES',
        COMPANY_USER: 'COMPANY_USER',
    },
    USER_TYPES: {
        MULTIFAMILY_CUSTOMER: 'multifamilyCustomer',
        ROCKETSHIP_CUSTOMER: 'rocketShipCustomer',
        NUCLEUS_CUSTOMER: 'nucleusCustomer',
    },
    PERMISSION_ROLES: {
        ADD_LISTING: 'propertyManagerAddProperty',
        UPDATE_LISTING: 'propertyManagerUpdateListing',
        VIEW_INVOICE: 'propertyManagerViewInvoice',
        VIEW_CONTACT: 'propertyManagerViewContact',
        RESPOND_REVIEW: 'propertyManagerRespondToReview',
        VIEW_ANALYTICS: 'propertyManagerViewAnalytics',
        COMPANY_ADMIN: 'propertyManagerCompanyAdmin',
        SYNC_PROPERTIES: 'propertyManagerAllProperties',
        COMPANY_USER: 'propertyManagerCompanyUser',
    },
    DESCRIPTION: {
        ADD_LISTING: {
            TITLE: 'Listing',
            DESCRIPTION: 'Add properties',
        },
        UPDATE_LISTING: {
            TITLE: 'Listing',
            DESCRIPTION: 'Update properties',
        },
        VIEW_INVOICE: {
            TITLE: 'Billing',
            DESCRIPTION: 'View invoices',
        },
        VIEW_CONTACT: {
            TITLE: 'Contacts',
            DESCRIPTION: 'View contacts',
        },
        RESPOND_REVIEW: {
            TITLE: 'Reviews',
            DESCRIPTION: 'Respond to reviews',
        },
        VIEW_ANALYTICS: {
            TITLE: 'Analytics',
            DESCRIPTION: 'Access to analytics dashboard',
        },
        COMPANY_ADMIN: {
            TITLE: 'Company admin',
            DESCRIPTION: 'Add / remove users. Access to all company properties and permissions.',
        },
    },
};

export default UserPermissionsConstants;
